var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControlCamera = function SvgControlCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1FF66",
    d: "M5.997 7.61q-.668 0-1.133-.464a1.54 1.54 0 0 1-.465-1.133q0-.67.465-1.133.465-.465 1.133-.465t1.133.465.465 1.133-.465 1.133-1.133.465m0 4.39L3.48 9.478l.676-.675 1.85 1.85 1.84-1.84.665.672zM2.515 8.534 0 6.02l2.521-2.522.676.676-1.85 1.85 1.84 1.84zm1.632-5.353-.672-.666L5.991 0l2.521 2.515-.675.676-1.85-1.85zm5.338 5.347-.676-.676 1.85-1.85-1.84-1.839.666-.666L12 6.013z"
  })));
};
export default SvgControlCamera;